// Local translations
export const T = {
  en_GB: {
    sumsubLivenessVerification: "Liveness Verification",
    sumsubLivenessVerificationDesc: "Enable biometric liveness detection",
  },
  nb_NO: {
    sumsubLivenessVerification: "Livsverifisering",
    sumsubLivenessVerificationDesc: "Aktiver biometrisk livlighetspåvisning",
  },
} as const;
